import React from 'react';
import { useIntl } from 'react-intl-next';
import CodeBidiWarning from '@atlaskit/code/bidi-warning';
import { codeBidiWarningMessages } from '@atlaskit/editor-common/messages';
import codeBidiWarningDecorator from '@atlaskit/code/bidi-warning-decorator';
export const useBidiWarnings = ({
  enableWarningTooltip = true
}) => {
  const intl = useIntl();
  const warningLabel = intl.formatMessage(codeBidiWarningMessages.label);
  const renderBidiWarnings = text => {
    return codeBidiWarningDecorator(text, ({
      bidiCharacter,
      index
    }) => /*#__PURE__*/React.createElement(CodeBidiWarning, {
      bidiCharacter: bidiCharacter,
      key: index,
      label: warningLabel,
      tooltipEnabled: enableWarningTooltip
    }));
  };
  return {
    renderBidiWarnings,
    warningLabel
  };
};